<template>
  <div class="column landing_buy_blu_watch">
    <div>
      <div class="column columns">
        <blu-watch-step1
          :purchaseHome="purchaseWaiting"
          @backToStart="backToStart"
        ></blu-watch-step1>
      </div>
    </div>
  </div>
</template>

<script>
import BluWatchStep1 from "./steps/BluWatchStep1";

export default {
  props: ["fees", "bluTusd", "purchaseWaiting"],
  created() {
  },
  mounted() {},
  data: () => ({
    step: 1,
    fakeQRcode: "54fhdskhfdshfis979f",
    btcAmount: 0,
    trade: false,
    btcAccount: "",
    updateActive: "",
    waitingStepPurchase: false,

  }),
  components: {
    BluWatchStep1
  },
  methods: {
    backToStart(){
      this.$emit("backToStart");
    },
    callNextState() {
      this.$emit("callNextState");
    },
  },
  computed: {},
  watch: {}
};
</script>


// WEBPACK FOOTER //
// src/components/private/landing/base_buy_blu/BaseBuyBluWatch.vue